import { render, staticRenderFns } from "./pemanfaatan_pangan.vue?vue&type=template&id=6fadf295&"
import script from "./pemanfaatan_pangan.vue?vue&type=script&lang=js&"
export * from "./pemanfaatan_pangan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports